export default function EmptyState({ title = 'Nothing here yet', message = 'Try changing your search or filters.', icon = 'bi-inbox' }: { title?: string; message?: string; icon?: string }) {
  return <div className="empty-state"><span><i className={`bi ${icon}`} /></span><h3>{title}</h3><p>{message}</p></div>
}
